import { useCallback } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router";

/**
 * A sheet whose open state lives in the URL (`?sheet=<name>`): opening pushes a history entry, so the Back
 * gesture/button closes the sheet; a shared link opens it directly (e.g. `?sheet=pay`).
 */
export function useUrlSheet(name: string): [boolean, (open: boolean) => void] {
  const [search, setSearch] = useSearchParams();
  const navigate = useNavigate();
  const location = useLocation();
  const open = search.get("sheet") === name;
  const openedHere = (location.state as { sheet?: string } | null)?.sheet === name;

  const setOpen = useCallback(
    (next: boolean) => {
      if (next === open) return;
      if (next) {
        const params = new URLSearchParams(search);
        params.set("sheet", name);
        setSearch(params, { preventScrollReset: true, state: { sheet: name } });
      } else if (openedHere) {
        void navigate(-1);
      } else {
        const params = new URLSearchParams(search);
        params.delete("sheet");
        setSearch(params, { preventScrollReset: true, replace: true });
      }
    },
    [open, openedHere, name, search, setSearch, navigate],
  );
  return [open, setOpen];
}
